// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"30d6f7205a01c26e71cd","452":"cb831dbdcb62d76bfdba","896":"3bef155142d2ee7cb786"}[chunkId] + ".js";
};